import React from 'react';
import { Link } from 'react-router-dom';
import { Users, ArrowRight } from 'lucide-react';
import { clients } from '../../data/mockData';

const ClientsSection = () => (
  <section className="py-16 md:py-24 bg-gradient-to-b from-[#f9fafb] to-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <div className="inline-flex items-center space-x-2 px-4 py-2 bg-amber-50 border border-amber-200 rounded-full mb-4">
          <Users className="h-4 w-4 text-amber-600" />
          <span className="text-amber-600 text-sm font-medium">Trusted Partnerships</span>
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Our Esteemed Clients</h2>
        <p className="text-gray-600 max-w-2xl mx-auto">Trusted by leading organizations across India and abroad</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {clients.slice(0, 12).map((client, index) => (
          <div key={client.name} className="group relative" style={{ animationDelay: `${index * 0.05}s` }}>
            <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-blue-500/10 rounded-2xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            <div className="relative bg-white border border-gray-200 rounded-2xl p-4 flex items-center justify-center hover:border-cyan-300 transition-all duration-500 transform hover:-translate-y-1 hover:shadow-xl h-32">
              <img
                src={client.logo}
                alt={client.name}
                className="max-h-20 w-auto object-contain opacity-70 group-hover:opacity-100 transform group-hover:scale-110 transition-all duration-500"
              />
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-12">
        <Link
          to="/clients"
          className="inline-flex items-center space-x-2 px-8 py-4 bg-white border-2 border-gray-300 text-gray-700 rounded-xl font-semibold hover:border-cyan-300 hover:bg-cyan-50 hover:text-cyan-700 transition-all duration-300 transform hover:scale-105"
        >
          <span>View All Clients</span>
          <ArrowRight className="h-5 w-5" />
        </Link>
      </div>

      <p className="text-center text-xs text-gray-400 mt-8">
        *All Trademarks, Logos and Brand Names are the property of their Respective Owners.
      </p>
    </div>
  </section>
);

export default ClientsSection;
